"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.HilPackageStoreResolutionProperties = void 0;
const z = __importStar(require("zod"));
const merge_values_js_1 = require("../utils/merge-values.js");
const merge_records_js_1 = require("../utils/merge-records.js");
const merge_records_dto_schema_js_1 = require("../utils/merge-records-dto-schema.js");
const cadstrom_shared_1 = require("@cadstrom/cadstrom-shared");
const hilPackageStoreResolutionPropertiesSchema = z.object({
    packageId: z.string().nullable().default(null),
    signalMap: z.record(z.union([z.string(), z.number()]), z.union([z.string(), z.number()]).nullable()).prefault({}),
    packageInfo: z
        .object({
        manufacturerPartNumber: z.string(),
        status: z.nativeEnum(cadstrom_shared_1.PackageStatus),
        datasheetFileId: z.string().nullable(),
        datasheetSource: z.string().nullable(),
        tags: z.array(cadstrom_shared_1.TagIdentifierSchema).default([]),
    })
        .nullable()
        .default(null),
});
const hilPackageStoreResolutionPropertiesDtoSchema = z.object({
    packageId: z.string().nullable().optional(),
    signalMap: (0, merge_records_dto_schema_js_1.mergeRecordsDtoSchema)(z.union([z.string(), z.number()]).nullable(), z.union([z.string(), z.number()]).nullable()).optional(),
});
exports.HilPackageStoreResolutionProperties = {
    create: (input) => {
        return hilPackageStoreResolutionPropertiesSchema.parse(input);
    },
    merge: (existing, incoming) => ({
        packageId: (0, merge_values_js_1.mergeValues)(existing.packageId, incoming.packageId),
        packageInfo: existing.packageInfo,
        signalMap: (0, merge_records_js_1.mergeRecords)(existing.signalMap, incoming.signalMap, (merge_values_js_1.mergeValues)),
    }),
    schema: hilPackageStoreResolutionPropertiesSchema,
    dtoSchema: hilPackageStoreResolutionPropertiesDtoSchema,
};
//# sourceMappingURL=hil-package-store-resolution-properties.js.map